import React from 'react';
import ResetPasswordChange from "v4/pages/front/ResetPassword/components/ResetPasswordChange/ResetPasswordChange";
import ResetPasswordRequest from "v4/pages/front/ResetPassword/components/ResetPasswordRequest/ResetPasswordRequest";
import {useNavigation} from "v4/features/front/navigation/contexts/NavigationContext";

export default function ResetPasswordPage() {
    const {currentRoute} = useNavigation();
    const userId = currentRoute?.params?.user;
    const searchParams = new URLSearchParams(window.location.search);
    const token = searchParams.get('token');

    if (userId) return <ResetPasswordChange userId={userId} token={token}/>;

    return <ResetPasswordRequest/>
}
